import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from "@/Components/ui/button";
import PropTypes from 'prop-types';
import icon1 from '../../images/dieets/1.png';
import icon2 from '../../images/dieets/2.png';
import icon3 from '../../images/dieets/3.png';
import icon4 from '../../images/dieets/4.png';
import icon5 from '../../images/dieets/5.png';
import icon6 from '../../images/dieets/6.png';
import icon7 from '../../images/dieets/7.png';
import icon8 from '../../images/dieets/8.png';
import icon9 from '../../images/dieets/9.png';
import icon10 from '../../images/dieets/10.png'; 

// Definieer DIETARY_NEEDS buiten de component met alleen id en icon
const DIETARY_NEEDS = [
    { id: 1, icon: icon1 },
    { id: 2, icon: icon2 },
    { id: 3, icon: icon3 },
    { id: 4, icon: icon4 },
    { id: 5, icon: icon5 },
    { id: 6, icon: icon6 },
    { id: 7, icon: icon7 },
    { id: 8, icon: icon8 },
    { id: 9, icon: icon9 },
    { id: 10, icon: icon10 }
];

const DietaryDisplay = ({ dietary }) => {
    const { t } = useTranslation();
    const dietaryName = t(`dietary.${dietary.id}`, 'Onbekend dieet');
    return (
        <span className="font-inter">{dietaryName}</span>
    );
};

const DietaryNeedsModal = ({ isOpen, onClose, onSave, selectedDietaryNeeds = [] }) => {
    const { t } = useTranslation();
    const [selected, setSelected] = React.useState(selectedDietaryNeeds);
     
    const handleToggle = (need) => {
        setSelected(prev =>
            prev.find(item => item.id === need.id)
                ? prev.filter(item => item.id !== need.id)
                : [...prev, need]
        );
    };

    const handleSave = () => {
        onSave(selected);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
                >
                    <X size={24} />
                </button>

                <h2 className="text-xl font-inter text-ps-blue-dark mb-4">
                    {t('modals.selectDietaryNeeds')}
                </h2>

                <div className="space-y-2 mb-6">
                    {DIETARY_NEEDS.map((need) => (
                        <div
                            key={need.id}
                            className="flex items-center gap-3 p-2 cursor-pointer hover:bg-gray-50 rounded"
                            onClick={() => handleToggle(need)}
                        >
                            <input
                                type="checkbox"
                                checked={selected.some(item => item.id === need.id)}
                                readOnly
                                className="w-4 h-4"
                            />
                            <img
                                src={need.icon}
                                alt={t(`dietary.${need.id}`)}
                                className="w-6 h-6"
                            />
                            <DietaryDisplay dietary={need} />
                        </div>
                    ))}
                </div>

                <div className="flex justify-end gap-4">
                    <Button
                        onClick={handleSave}
                        className="bg-ps-green w-40 hover:bg-ps-green/90 text-white font-inter"
                    >
                        {t('common.ok')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

DietaryNeedsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    selectedDietaryNeeds: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    )
};

export default DietaryNeedsModal;